var _style, _defs, _polygon, _g, _g2, _rect, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 94 64",
    style: {
      enableBackground: "new 0 0 94 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.no-show{display:none;}\n\t.white-fill{fill:#FFFFFF;}\n\t.red-fill{fill:#E02826;}\n\t.fill-none{fill:none;stroke:#FFFFFF;stroke-width:1.4404;stroke-miterlimit:10;}\n\t.blue-fill{fill:#19468D;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Colored_BG"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -316,
    y: 51.5,
    width: 321,
    height: 92
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "94,63.8 -0.1,63.8 -0.1,0.2 94,0.2 94,14.6  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "red-fill",
    points: "92.5,47.5 92.5,51.3 1.7,51.3 1.7,47.5 2.3,47.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "92.5,43.6 92.5,47.5 2.3,47.5 1.7,47.5 1.7,43.6 3.3,43.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "red-fill",
    points: "92.5,39.7 92.5,43.6 3.3,43.6 1.7,43.6 1.7,39.7 92.1,39.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "92.5,36 92.5,39.7 92.1,39.7 1.7,39.7 1.7,36 2.7,36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "red-fill",
    points: "92.5,32.4 92.5,36 2.7,36 1.7,36 1.7,32.4 1.8,32.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "92.5,28.6 92.5,32.4 1.8,32.4 1.7,32.4 1.7,28.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "red-fill",
    points: "92.5,25.1 92.5,28.6 1.7,28.6 1.7,25.1 92.2,25.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "92.5,20.9 92.5,25.1 92.2,25.1 1.7,25.1 1.7,20.9 92.4,20.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "red-fill",
    points: "92.5,17 92.5,20.9 92.4,20.9 1.7,20.9 1.7,17 1.9,17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "92.5,13.1 92.5,17 1.9,17 1.7,17 1.7,13.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "red-fill",
    points: "92.5,9.4 92.5,13.1 1.7,13.1 1.7,9.4 1.8,9.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "92.5,5.5 92.5,9.4 1.8,9.4 1.7,9.4 1.7,5.5 92.4,5.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "red-fill",
    points: "92.5,2.6 92.5,5.5 92.4,5.5 1.7,5.5 1.7,2.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.7,
    y: 1.8,
    className: "white-fill",
    width: 90.8,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "fill-none",
    points: "92.5,47.5 92.5,51.3 1.7,51.3 1.7,47.5 1.7,43.6 1.7,39.7 1.7,36 1.7,32.4 1.7,28.6 1.7,25.1  1.7,20.9 1.7,17 1.7,13.1 1.7,9.4 1.7,5.5 1.7,2.6 1.7,1.8 92.5,1.8 92.5,2.6 92.5,5.5 92.5,9.4 92.5,13.1 92.5,17 92.5,20.9  92.5,25.1 92.5,28.6 92.5,32.4 92.5,36 92.5,39.7 92.5,43.6  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M5.3,62.2l-1.5-6.9H3.7c0.1,0.5,0.1,1,0.1,1.5v5.5H2.4v-8.1h2.3l1.4,6.4h0l1.4-6.4h2.4v8.1H8.4v-5.5 c0-0.5,0-0.9,0.1-1.4h0l-1.5,6.9H5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M15.6,62.2l-0.5-2.1H13l-0.5,2.1h-1.5l2-8.2h2.1l2,8.2H15.6z M14.9,58.8l-0.4-1.9c0-0.1-0.1-0.4-0.2-0.9 c-0.1-0.5-0.1-0.8-0.2-0.9c0,0.3-0.1,0.7-0.2,1.1c-0.1,0.4-0.3,1.3-0.6,2.6H14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M23.5,58.1c0,1.3-0.3,2.4-0.8,3.1c-0.5,0.7-1.3,1.1-2.4,1.1h-2v-8.1h2.2c0.9,0,1.7,0.4,2.2,1 C23.2,55.8,23.5,56.8,23.5,58.1z M22,58.1c0-1.8-0.5-2.7-1.5-2.7h-0.6v5.5h0.5c0.6,0,1-0.2,1.2-0.7C21.8,59.7,22,59.1,22,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M28.8,62.2h-3.7v-8.1h3.7v1.3h-2.2v1.9h2v1.3h-2v2.3h2.2V62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M34.2,62.2v-8.1h1.4v8.1H34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M43.8,62.2h-1.8l-2.5-5.9h-0.1c0.1,0.4,0.1,0.9,0.1,1.4v4.5h-1.4v-8.1h1.9l2.5,5.8h0.1 c-0.1-0.4-0.1-0.9-0.1-1.4v-4.4h1.4V62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M50.8,62.2h-1.5v-6.8h-1.6v-1.3h4.6v1.3h-1.6V62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M59.4,62.2h-1.5v-3.6h-2v3.6h-1.5v-8.1h1.5v3.2h2v-3.2h1.5V62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M65.7,62.2H62v-8.1h3.7v1.3h-2.2v1.9h2v1.3h-2v2.3h2.2V62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M77,54.1v5.3c0,1-0.2,1.7-0.7,2.2c-0.4,0.5-1.1,0.8-1.9,0.8c-0.8,0-1.4-0.3-1.8-0.8 c-0.4-0.5-0.6-1.3-0.6-2.2v-5.2h1.5v5.4c0,1,0.3,1.6,1,1.6c0.3,0,0.6-0.1,0.7-0.4c0.2-0.3,0.3-0.6,0.3-1.1v-5.4H77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M83.2,60c0,0.8-0.2,1.3-0.6,1.7c-0.4,0.4-0.9,0.6-1.7,0.6c-0.7,0-1.3-0.1-1.8-0.4v-1.5 c0.6,0.4,1.2,0.6,1.7,0.6c0.3,0,0.5-0.1,0.7-0.2c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.5-0.5-0.9-0.7 c-0.3-0.2-0.6-0.5-0.8-0.7c-0.2-0.2-0.3-0.5-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-1c0-0.7,0.2-1.3,0.6-1.7c0.4-0.4,0.9-0.6,1.6-0.6 c0.6,0,1.2,0.2,1.8,0.5l-0.5,1.2c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0.1-0.6,0.2 c-0.1,0.2-0.2,0.4-0.2,0.7c0,0.3,0.1,0.5,0.2,0.7c0.2,0.2,0.4,0.4,0.8,0.7c0.5,0.4,0.9,0.7,1.1,1.1C83.1,59.1,83.2,59.5,83.2,60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "blue-fill",
    d: "M89.2,62.2l-0.5-2.1h-2.1l-0.5,2.1h-1.5l2-8.2h2.1l2,8.2H89.2z M88.5,58.8L88,56.9c0-0.1-0.1-0.4-0.2-0.9 c-0.1-0.5-0.1-0.8-0.2-0.9c0,0.3-0.1,0.7-0.2,1.1c-0.1,0.4-0.3,1.3-0.6,2.6H88.5z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.4,
    y: 2.6,
    className: "blue-fill",
    width: 40.8,
    height: 26.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "5.3,6.6 4.4,7.2 4.7,6.1 3.8,5.5 4.8,5.5 5.3,4.6 5.7,5.5 6.8,5.5 5.9,6.1 6.2,7.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "5.3,11.4 4.4,12.1 4.7,11 3.8,10.3 4.8,10.3 5.3,9.4 5.7,10.3 6.8,10.3 5.9,11 6.2,12.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "5.3,16.3 4.4,16.9 4.7,15.8 3.8,15.2 4.8,15.2 5.3,14.2 5.7,15.2 6.8,15.2 5.9,15.8 6.2,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "5.3,21.1 4.4,21.7 4.7,20.6 3.8,20 4.8,20 5.3,19.1 5.7,20 6.8,20 5.9,20.6 6.2,21.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "5.3,26 4.4,26.6 4.7,25.5 3.8,24.9 4.8,24.9 5.3,23.9 5.7,24.9 6.8,24.9 5.9,25.5 6.2,26.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "8.7,9 7.8,9.7 8.1,8.6 7.2,7.9 8.2,7.9 8.7,7 9.1,7.9 10.2,7.9 9.3,8.6 9.6,9.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "8.7,13.9 7.8,14.5 8.1,13.4 7.2,12.8 8.2,12.8 8.7,11.8 9.1,12.8 10.2,12.8 9.3,13.4 9.6,14.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "8.7,18.7 7.8,19.3 8.1,18.2 7.2,17.6 8.2,17.6 8.7,16.7 9.1,17.6 10.2,17.6 9.3,18.2 9.6,19.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "8.7,23.5 7.8,24.2 8.1,23.1 7.2,22.4 8.2,22.4 8.7,21.5 9.1,22.4 10.2,22.4 9.3,23.1 9.6,24.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "15.6,9 14.7,9.7 15,8.6 14.2,7.9 15.2,7.9 15.6,7 16.1,7.9 17.1,7.9 16.2,8.6 16.5,9.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "15.6,13.9 14.7,14.5 15,13.4 14.2,12.8 15.2,12.8 15.6,11.8 16.1,12.8 17.1,12.8 16.2,13.4  16.5,14.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "15.6,18.7 14.7,19.3 15,18.2 14.2,17.6 15.2,17.6 15.6,16.7 16.1,17.6 17.1,17.6 16.2,18.2  16.5,19.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "15.6,23.5 14.7,24.2 15,23.1 14.2,22.4 15.2,22.4 15.6,21.5 16.1,22.4 17.1,22.4 16.2,23.1  16.5,24.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "22.6,9 21.7,9.7 22,8.6 21.1,7.9 22.1,7.9 22.6,7 23,7.9 24,7.9 23.2,8.6 23.5,9.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "22.6,13.9 21.7,14.5 22,13.4 21.1,12.8 22.1,12.8 22.6,11.8 23,12.8 24,12.8 23.2,13.4 23.5,14.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "22.6,18.7 21.7,19.3 22,18.2 21.1,17.6 22.1,17.6 22.6,16.7 23,17.6 24,17.6 23.2,18.2 23.5,19.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "22.6,23.5 21.7,24.2 22,23.1 21.1,22.4 22.1,22.4 22.6,21.5 23,22.4 24,22.4 23.2,23.1 23.5,24.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "29.5,9 28.6,9.7 28.9,8.6 28,7.9 29,7.9 29.5,7 30,7.9 31,7.9 30.1,8.6 30.4,9.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "29.5,13.9 28.6,14.5 28.9,13.4 28,12.8 29,12.8 29.5,11.8 30,12.8 31,12.8 30.1,13.4 30.4,14.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "29.5,18.7 28.6,19.3 28.9,18.2 28,17.6 29,17.6 29.5,16.7 30,17.6 31,17.6 30.1,18.2 30.4,19.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "29.5,23.5 28.6,24.2 28.9,23.1 28,22.4 29,22.4 29.5,21.5 30,22.4 31,22.4 30.1,23.1 30.4,24.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "36.4,9 35.5,9.7 35.9,8.6 35,7.9 36,7.9 36.4,7 36.9,7.9 37.9,7.9 37,8.6 37.4,9.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "36.4,13.9 35.5,14.5 35.9,13.4 35,12.8 36,12.8 36.4,11.8 36.9,12.8 37.9,12.8 37,13.4 37.4,14.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "36.4,18.7 35.5,19.3 35.9,18.2 35,17.6 36,17.6 36.4,16.7 36.9,17.6 37.9,17.6 37,18.2 37.4,19.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "36.4,23.5 35.5,24.2 35.9,23.1 35,22.4 36,22.4 36.4,21.5 36.9,22.4 37.9,22.4 37,23.1 37.4,24.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "12.2,6.6 11.2,7.3 11.6,6.2 10.7,5.5 11.7,5.5 12.2,4.6 12.6,5.5 13.6,5.5 12.7,6.2 13.1,7.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "12.2,11.5 11.2,12.1 11.6,11 10.7,10.4 11.7,10.4 12.2,9.4 12.6,10.4 13.6,10.4 12.7,11 13.1,12.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "12.2,16.3 11.2,16.9 11.6,15.8 10.7,15.2 11.7,15.2 12.2,14.3 12.6,15.2 13.6,15.2 12.7,15.8  13.1,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "12.2,21.1 11.2,21.8 11.6,20.7 10.7,20 11.7,20 12.2,19.1 12.6,20 13.6,20 12.7,20.7 13.1,21.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "12.2,26 11.2,26.6 11.6,25.5 10.7,24.9 11.7,24.9 12.2,23.9 12.6,24.9 13.6,24.9 12.7,25.5  13.1,26.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "19.1,6.6 18.2,7.3 18.5,6.2 17.6,5.5 18.6,5.5 19.1,4.6 19.5,5.5 20.6,5.5 19.7,6.2 20,7.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "19.1,11.5 18.2,12.1 18.5,11 17.6,10.4 18.6,10.4 19.1,9.4 19.5,10.4 20.6,10.4 19.7,11 20,12.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "19.1,16.3 18.2,16.9 18.5,15.8 17.6,15.2 18.6,15.2 19.1,14.3 19.5,15.2 20.6,15.2 19.7,15.8  20,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "19.1,21.1 18.2,21.8 18.5,20.7 17.6,20 18.6,20 19.1,19.1 19.5,20 20.6,20 19.7,20.7 20,21.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "19.1,26 18.2,26.6 18.5,25.5 17.6,24.9 18.6,24.9 19.1,23.9 19.5,24.9 20.6,24.9 19.7,25.5 20,26.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "26,6.6 25.1,7.3 25.4,6.2 24.6,5.5 25.6,5.5 26,4.6 26.5,5.5 27.5,5.5 26.6,6.2 26.9,7.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "26,11.5 25.1,12.1 25.4,11 24.6,10.4 25.6,10.4 26,9.4 26.5,10.4 27.5,10.4 26.6,11 26.9,12.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "26,16.3 25.1,16.9 25.4,15.8 24.6,15.2 25.6,15.2 26,14.3 26.5,15.2 27.5,15.2 26.6,15.8 26.9,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "26,21.1 25.1,21.8 25.4,20.7 24.6,20 25.6,20 26,19.1 26.5,20 27.5,20 26.6,20.7 26.9,21.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "26,26 25.1,26.6 25.4,25.5 24.6,24.9 25.6,24.9 26,23.9 26.5,24.9 27.5,24.9 26.6,25.5 26.9,26.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "33,6.6 32.1,7.3 32.4,6.2 31.5,5.5 32.5,5.5 33,4.6 33.4,5.5 34.4,5.5 33.6,6.2 33.9,7.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "33,11.5 32.1,12.1 32.4,11 31.5,10.4 32.5,10.4 33,9.4 33.4,10.4 34.4,10.4 33.6,11 33.9,12.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "33,16.3 32.1,16.9 32.4,15.8 31.5,15.2 32.5,15.2 33,14.3 33.4,15.2 34.4,15.2 33.6,15.8 33.9,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "33,21.1 32.1,21.8 32.4,20.7 31.5,20 32.5,20 33,19.1 33.4,20 34.4,20 33.6,20.7 33.9,21.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "33,26 32.1,26.6 32.4,25.5 31.5,24.9 32.5,24.9 33,23.9 33.4,24.9 34.4,24.9 33.6,25.5 33.9,26.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "39.9,6.6 39,7.3 39.3,6.2 38.4,5.5 39.5,5.5 39.9,4.6 40.4,5.5 41.4,5.5 40.5,6.2 40.8,7.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "39.9,11.5 39,12.1 39.3,11 38.4,10.4 39.5,10.4 39.9,9.4 40.4,10.4 41.4,10.4 40.5,11 40.8,12.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "39.9,16.3 39,16.9 39.3,15.8 38.4,15.2 39.5,15.2 39.9,14.3 40.4,15.2 41.4,15.2 40.5,15.8  40.8,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "39.9,21.1 39,21.8 39.3,20.7 38.4,20 39.5,20 39.9,19.1 40.4,20 41.4,20 40.5,20.7 40.8,21.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white-fill",
    points: "39.9,26 39,26.6 39.3,25.5 38.4,24.9 39.5,24.9 39.9,23.9 40.4,24.9 41.4,24.9 40.5,25.5 40.8,26.6  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Original",
    className: "no-show"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Outlined"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.e2426e4d9f382dee636acd46cc095aad.svg";
export { ForwardRef as ReactComponent };